module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt_BR":{"option":"Selecione uma opção","utiliza-rd":{"label":"Você já utiliza o RD Station?","no":"Não","yes":"Sim"},"plano-rd":{"label":"Qual seu plano RD Station?","basic":"Basic","pro":"Pro","enterprise":"Enterprise","agencia":"Sou uma agência"},"no-rd":{"0":"Sim, para a minha empresa","1":"Sim, sou uma agência","2":"Não, já utilizo outra ferramenta","3":"Na verdade, nunca ouvi falar","label":"Tem interesse em utilizar o RD Station?"}}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/Auth/Steps/Second.vue
// module id = 142
// module chunks = 0